import { createAction } from 'redux-act';
//////////////////////////////////////////////////

// common
export const getTrailerGeneralDetailsRequest = createAction('getTrailerGeneralDetailsRequest');
export const updateTrailerGeneralDetailsRequest = createAction('updateTrailerGeneralDetailsRequest');
// configs
export const getTrailerBranchConfigsRequest = createAction('getTrailerBranchConfigsRequest');
